module.exports = __webpack_public_path__ + "img/building_construction.328118ab.jpg";